export default function LibraryIcon({ stroke }) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 11.2H4.6C4.03995 11.2 3.75992 11.2 3.54601 11.309C3.35785 11.4049 3.20487 11.5579 3.10899 11.746C3 11.9599 3 12.24 3 12.8V21.2M16.5 11.2H19.4C19.9601 11.2 20.2401 11.2 20.454 11.309C20.6422 11.4049 20.7951 11.5579 20.891 11.746C21 11.9599 21 12.24 21 12.8V21.2M16.5 21.2V6.40001C16.5 5.27991 16.5 4.71985 16.282 4.29203C16.0903 3.91571 15.7843 3.60975 15.408 3.418C14.9802 3.20001 14.4201 3.20001 13.3 3.20001H10.7C9.57989 3.20001 9.01984 3.20001 8.59202 3.418C8.21569 3.60975 7.90973 3.91571 7.71799 4.29203C7.5 4.71985 7.5 5.27991 7.5 6.40001V21.2M22 21.2H2M11 7.20001H13M11 11.2H13M11 15.2H13"
        stroke={stroke || '#A4BCFD'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
